import ApiRequests from "../apiRequests";

class OrderService extends ApiRequests {
  constructor() {
    super("orders/admin");
  }
}

export default OrderService;
